export default __webpack_public_path__ + "static/media/bg-masthead-3-640w.1d73d7f8.webp";